export default __webpack_public_path__ + "static/media/HASSAN_NL_SEQ04.bc0001e6.mp3";